import { IpaType } from "./ipa";
import { PhonemeItem } from "./segmentPhonemes";

/**
 * get a list of everything in phonemes that should be replaced
 * in order to make it pronounceable, including unknown symbols
 * and choices (e.g., f~v),
 * provide a list of symbols & suggested alternatives for the symbols
 */
export function getAlternates(
  phonemes: PhonemeItem[], lookup: Record<string, IpaType>, multiLookup: Record<string, IpaType>
): string[][] {
  const multi = getMulti(phonemes, multiLookup);
  const unknown = getUnknowns(phonemes, lookup);
  const choices = getChoices(phonemes);
  return multi.concat(unknown).concat(choices);
}

/** get a list of [unknown-combo, alternative] */
function getMulti(phonemes: PhonemeItem[], multiLookup: Record<string, IpaType>): string[][] {
  const map: string[][] = [];
  const s = phonemes.map(p => p.phoneme).join('');
  for (const combo of Object.getOwnPropertyNames(multiLookup)) {
    if (s.includes(combo)) {
      map.push([combo, multiLookup[combo]]);
    }
  }
  return map; // [['ẋ', 'χ']];
}

/** get a list of [unknown-symbol, alternative] */
function getUnknowns(phonemes: PhonemeItem[], lookup: Record<string, IpaType>): string[][] {
  const unknown = phonemes.filter(p => p.meta === 'unknown');
  const seen: Set<string> = new Set();
  const map: string[][] = [];
  unknown.forEach(p => {
    const s = p.phoneme;
    if (!seen.has(s)) {
      seen.add(s);
      const alt = lookup[s];
      map.push([s, alt ?? '']);
    }
  });
  return map;
}

/** get a list of [1~2, alternative] */
function getChoices(phonemes: PhonemeItem[]): string[][] {
  const seen: Set<string> = new Set();
  const map: string[][] = [];
  for (let i = 0; i < phonemes.length - 2; i++) {
    if (phonemes[i + 1].phoneme === '~') {
      const first = phonemes[i].phoneme;

      // possibly add multiple, e.g., a~b~c~d
      let s = first;
      do {
        i += 2;
        s += '~' + phonemes[i].phoneme;
      } while (phonemes[i + 1]?.phoneme === '~');

      if (!seen.has(s)) {
        seen.add(s);
        map.push([s, first]); // e.g., ['f~v', 'f']
      }
    }
  }
  return map;
}
